import { IFText, IFButton } from 'Components'
import PropTypes from 'prop-types'
import Styles from './InviteOperatorUserListItem.module.css'
import styled from 'styled-components'
import Colors from 'Theme/Colors'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import React, { useState, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'
import { styled as muiStyled } from '@mui/system'

const PenIcon = styled.div`
  color: ${Colors.OperatorUserListPenIcon};
`

const InviteOperatorUserListItem = React.forwardRef(
  (
    {
      operatorUser,
      avatar,
      permissions,
      onDeleteClick,
      isDeleteLoading,
      onResendClick,
      isResendLoading,
    },
    ref,
  ) => {
    const { t } = useTranslation()

    const [accordExpanded, setAccordExpanded] = useState(false)

    const collapse = () => {
      setAccordExpanded(false)
    }

    useImperativeHandle(ref, () => ({
      collapse,
    }))

    const getPermissionPlaceholder = () => {
      let result = ''
      if (permissions[0] && permissions[1])
        result = `${permissions[0]} + ${permissions.length - 1}`
      else if (permissions[0]) result = permissions[0]
      else result = t('OperatorUserListItem.NoPermissionsSelected')
      return result
    }

    const onClickAccordionHandler = () => {
      setAccordExpanded((expanded) => {
        return !expanded
      })
    }

    const StyledAccordion = muiStyled(Accordion)({
      width: '100%',
      boxShadow: `0px 0px 0px 0px ${Colors.red}`,
      paddingRight: '1rem',
      paddingLeft: '1rem',
    })

    return (
      <div className={Styles.Container}>
        <StyledAccordion
          onClick={onClickAccordionHandler}
          expanded={accordExpanded}
        >
          <AccordionSummary>
            <div className={Styles.ListItemSummary}>
              <div className={Styles.AvatarNameEmail}>
                <div className={Styles.AvatarIcon}>{avatar}</div>
                <div className={Styles.NameEmail}>
                  <IFText className={Styles.Name}>{operatorUser.email}</IFText>
                  <IFText
                    className={Styles.Email}
                    style={{ color: Colors.OperatorUserListItemEmail }}
                  >
                    {t('InviteOperatorUserListItem.InvitationSent')}
                  </IFText>
                </div>
              </div>

              <div
                className={
                  accordExpanded
                    ? Styles.PermissionsContainerExpanded
                    : Styles.PermissionsContainer
                }
              >
                <IFText
                  style={{ backgroundColor: Colors.GreyBackground }}
                  className={Styles.Role}
                >
                  {getPermissionPlaceholder()}
                </IFText>
              </div>

              {!accordExpanded ? (
                <PenIcon className={Styles.PenIcon}>
                  <FontAwesomeIcon icon={faPen} />
                </PenIcon>
              ) : null}
            </div>
          </AccordionSummary>

          <AccordionDetails
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <div className={Styles.ListItemDetails}>
              <IFButton
                color={Colors.red}
                text={t('InviteOperatorUserListItem.Delete')}
                isLoading={isDeleteLoading}
                size="xsm"
                isFill={false}
                className={Styles.DeleteButton}
                onClick={onDeleteClick}
              />

              <IFButton
                color={Colors.primary}
                text={t('InviteOperatorUserListItem.Resend')}
                isLoading={isResendLoading}
                size="xsm"
                isFill={true}
                className={Styles.ResendButton}
                onClick={onResendClick}
              />
            </div>
          </AccordionDetails>
        </StyledAccordion>
      </div>
    )
  },
)

InviteOperatorUserListItem.propTypes = {
  operatorUser: PropTypes.object,
  avatar: PropTypes.object,
  permissions: PropTypes.arrayOf(PropTypes.string),
  onResendClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  isDeleteLoading: PropTypes.bool,
  isResendLoading: PropTypes.bool,
}

export default InviteOperatorUserListItem
